<template>
<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M36 67.5C53.397 67.5 67.5 53.397 67.5 36C67.5 18.603 53.397 4.5 36 4.5C18.603 4.5 4.5 18.603 4.5 36C4.5 53.397 18.603 67.5 36 67.5Z" fill="url(#paint0_linear_120_992)"/>
<path d="M41.5053 19.4716C42.1861 18.2832 41.7791 16.7653 40.5963 16.0814C39.4135 15.3974 37.9026 15.8063 37.2217 16.9947L36.0344 19.0674L34.8469 16.9947C34.166 15.8063 32.6552 15.3974 31.4723 16.0814C30.2895 16.7653 29.8825 18.2832 30.5633 19.4716L33.183 24.0444L24.8967 38.5085H18.2212C16.8564 38.5085 15.75 39.62 15.75 40.9912C15.75 42.3623 16.8564 43.4738 18.2212 43.4738H41.4729C41.6768 42.9356 41.8914 42.0122 41.663 41.1635C41.3199 39.8878 40.05 38.5085 37.922 38.5085H30.5993L41.5053 19.4716Z" fill="white"/>
<path d="M26.1819 46.2193C25.7603 45.7488 24.8157 44.9971 23.9873 44.7498C22.7243 44.3725 21.7668 44.6092 21.2837 44.8153L19.443 48.0285C18.7622 49.2167 19.1692 50.7346 20.3521 51.4186C21.5349 52.1026 23.0456 51.6937 23.7265 50.5053L26.1819 46.2193Z" fill="white"/>
<path d="M50.0164 43.4738H53.7788C55.1437 43.4738 56.25 42.3623 56.25 40.9912C56.25 39.62 55.1437 38.5085 53.7788 38.5085H47.1719L39.7294 25.5175C39.1765 26.0453 38.1166 27.3938 37.9564 28.9226C37.7505 30.888 38.0592 32.5431 38.986 34.1638C42.1015 39.6126 45.2221 45.059 48.3421 50.5053C49.023 51.6938 50.5336 52.1026 51.7167 51.4186C52.8995 50.7346 53.3065 49.2167 52.6257 48.0285L50.0164 43.4738Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear_120_992" x1="36" y1="4.5" x2="36" y2="67.5" gradientUnits="userSpaceOnUse">
<stop stop-color="#2AC9FA"/>
<stop offset="1" stop-color="#1F65EB"/>
</linearGradient>
</defs>
</svg>



</template>

<script>
export default {
  name: 'IconWrongBrowser'
}
</script>
